import { useState } from "react";
import useEvent from "react-use-event-hook";

import { unique } from "@ryde/shared";

/** Stations quick-added in this form, so both home-side fields (pickup A, dropoff B) offer them. */
export const useAddedHomeStations = () => {
  const [addedStationIds, setAddedStationIds] = useState<number[]>([]);

  const onStationQuickAdded = useEvent((stationId: number): void => {
    setAddedStationIds(prev => unique([...prev, stationId]));
  });

  return { addedStationIds, onStationQuickAdded };
};
